<app-expandible-title [title]="'Grupo de carteira'"></app-expandible-title>

<div>
    <span>Nome: </span>
    <span class="font-weight-bold" *ngIf="data?.nome">{{data?.nome}}</span>
    <span class="font-weight-bold" *ngIf="data?.nomeGrupoCarteira">{{data?.nomeGrupoCarteira}}</span>
</div>
<div *ngIf="data?.descricao">
  <span>Descrição: </span>
  <span class="font-weight-bold">{{data?.descricao}}</span>
</div>

<div class="mt-5" *ngIf="data?.nomeCarteira">
  <span>Carteira Desassociada: </span>
</div>

<div class="container-fluid mb-5" *ngIf="data?.nomeCarteira" >
  <div class="row">
    <div class="col-12 mt-0">
      <table aria-label="Detalhes grupo de carteira"
             class="table label-maps table-striped table-bordered table-hover table-responsive-sm table-responsive-md table-responsive-xl">
        <thead>
        <tr>
          <th scope="col">Carteira</th>
        </tr>
        </thead>
        <tbody>
          <tr class="element-row">
            <td>{{ data?.nomeCarteira }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="mt-5" *ngIf="data?.carteiras && data?.carteiras.length > 0">
  <span>Carteiras Associadas: </span>
</div>

<div class="container-fluid mb-5" *ngIf="data?.carteiras && data?.carteiras.length > 0">
  <div class="row">
    <div class="col-12 mt-0">
      <app-total-table
        [showRegistersPerPage]="true"
        (onChange)="updatePageSize($event)"
        [totalRegistros]="this.totalRegistros"></app-total-table>
      <table aria-label="Detalhes grupo de carteira"
        class="table label-maps table-striped table-bordered table-hover table-responsive-sm table-responsive-md table-responsive-xl">
        <thead>
        <tr>
          <th scope="col">Carteira</th>
        </tr>
        </thead>
        <tbody>
        <ng-container *ngFor="let carteira of carteirasPaginadas">
          <tr class="element-row">
            <td>{{ carteira.nome }}</td>
          </tr>
        </ng-container>
        </tbody>
      </table>
    </div>
  </div>
  <div class="d-flex justify-content-center">
    <maps-pagination
      [pageNumber]="page$"
      [items]="paginationTotalPage"
      *ngIf="paginationTotalPage && paginationTotalPage > 1"
      (pageSend)="receiverPage($event)"
    ></maps-pagination>
  </div>
</div>
